import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import assert from 'assert';
import Helmet from 'react-helmet';
import { matchFormat, match } from '../utilities/parts';

import Auth from '../components/Auth';
import WorkScrollGroup from '../components/ScrollGroup';
import { WorkHourModal } from '../components/WorkHourModal';
import WorkSearchForm from '../components/WorkSearchForm';
import { SafetyDutyUserDropdown } from '../components/dropdowns/single/SafetyDutyUser';
import { CopyWorks } from '../components/modals/CopyWorks';
import { Modal } from '../components/Modal';
import WorkApproval from '../components/modals/WorkApproval';
import WorkResultManHours from '../components/modals/WorkResultManHours';
import { SafetyDutyModal } from '../components/modals/SafetyDutyModal';
import WorkScheduleManHours from '../components/modals/WorkScheduleManHours';
import Confirmation from '../components/modals/common/Confirmation';
import Information from '../components/modals/common/Information';
import SubContractorToggle from '../components/toggle/SubContractorToggle';
import CheckInNotReflectWorksDialog from '../components/modals/CheckInNotReflectWorksDialog';

import FieldItemInputsService from '../services/FieldItemInputs';
import { FieldService } from '../services/Fields';
import { FieldItemService } from '../services/FieldItems'; // 現場作業エリア情報取得API
import { PrintService } from '../services/Prints';
import SafetyDutyService from '../services/SafetyDuties';
import { WorkApprovalService } from '../services/WorkApprovals';
import { WorkScheduleService } from '../services/Works';
import LocalStorageService from '../services/utilities/LocalStorageService';
import urlParamManger from '../utilities/urlParamManager';

import { ReportSettingService } from '../services/ReportSettings';
import { ReportLists } from '../pages/ReportSettings';
import { WorkListReports } from '../components/modals/ListReports';

import {
  CONFERENCE_MODE,
  USER_ROLES,
  HEADER_CONSTANTS,
  SCHEDULE_STATUS,
  PARTNER_APPROVAL_NAME,
  API_FLAG,
  FILE_CODE,
  STATUS_CODE,
  LIST_LIMIT,
  WORK_TYPE,
  PRINTOUT_BUTTON_CLICK_BEHAVIOR,
  WORK_HOUR_ZONES,
} from '../utilities/constants';
import EventMg, { EventType } from '../utilities/EventManager';
import { LayoutDelegate } from '../utilities/LayoutDelegate';
import { messageUtility } from '../utilities/messageUtility';
import PrintUtility from '../utilities/printUtility';
import {
  isLoginUserPartner,
  isLoginUserForeman,
} from '../utilities/roleUtility';
import _slideLoader from '../utilities/slideLoader';
import WorksInfinityScrollLoad from '../components/WorksInfinityScrollLoad';
import UserProfileService from '../services/UserProfiles';
import ReloadHelper from '../services/utilities/ReloadHelper';
import fetchMg from '../utilities/fetchManager';
import dialogLoader from '../utilities/dialogLoader';
import { ErrorDialog } from '../components/dialogs/ErrorDialog';
import { FormInformationDialog } from '../components/FormInformationDialog.jsx';
import urlParamManager from '../utilities/urlParamManager';
import {
  onceAsyncRequest,
  blobToJsonConversion,
  isSafariStopVersion,
} from '../utilities/commonUtil';
import { ConferencePageHeader } from '../components/PageHeader';
import { QuestionIcon } from '../components/icons/QuestionIcon';
import Tippy from '../components/ReactTippy';
import UnapprovedWorksPageHeader from '../components/UnapprovedWorksPageHeader';
import SessionStorageService from '../services/utilities/SessionStorageService';
import EventManager from '../utilities/EventManager';
import WorkScheduleBatchEdit from './WorkScheduleMultipleEdit';
import WorkResultBatchEdit from './WorkResultMultipleEdit';

const modalList = {
  ConfirmSelected: 'CONFIRM_SELECTED', // 選択作業承認_確認
  ConfirmDeselected: 'CONFIRM_DESELECTED', // 選択作業承認解除_確認
  ApprovedDenied: 'Approved_Denied', // 承認・否認状態
  ApprovedDeniedMessage: 'Approved_Denied_Message', // // 承認・否認メッセージ
  ApprovedDeniedTitle: 'APPROVED_DENIED_TITLE',
  PartnerApprovalConfirm: 'PARTNER_APPROVAL_CONFIRM', // 協力会社承認_確認
  PartnerDenialConfirm: 'PARTNER_DENIAL_CONFIRM', // 協力会社否認_確認
  ScheduleRefrectToResult: 'SCHEDULE_REFLECT_TO_RESULT', // 実績に反映_確認
  ManHour: 'MAN_HOUR',
  ManHourInput: 'MAN_HOUR_INPUT',
  ApprovalStatus: 'APPROVAL_STAtUS', // 承認
  CopyWorks: 'COPY_WORKS',
  CopyWorksNotComplete: 'COPYWORKSNOTCOMPLETE',
  Unloaded: 'UNLOADED',
  WorkListReports: 'WORK_LIST_REPORTS',
  CompleteWorkScheduleReflectToResult:
    'COMPLETE_WORK_SCHEDULE_REFLECT_TO_RESULT',
  AlreadyWorkScheduleReflectToResult: 'ALREADY_WORK_SCHEDULE_REFLECT_TO_RESULT',
  Kikan: 'KIKAN',
  DynamicDesignationMessage: 'DYNAMIC_DESIGNATION_MESSAGE', // メッセージ指定_動的
  ReachMaxNumber: 'REACH_MAX_NUMBER',
  BatchUpdateIgnore: 'BATCH_UPDATE_IGORE',
  BatchUpdateConfirm: 'BATCH_UPDATE_CONFIRM_MESSAGE',
  DynamicSuccess: 'DYNAMIC_SUCCESS',
  DynamicSuccessMessage: 'DYNAMIC_SUCCESS_MESSAGE',
  DynamicSuccessTitle: 'DYNAMIC_SUCCESS_TITLE',
  CheckInNotReflectWorksDialog: 'CHECK_IN_NOT_REFLECT_WORKS',
  WorkReportDownloadError: 'WORK_REPORT_DOWNLOAD_ERROR',
};

const MY_EVENT = {
  LOAD_GROUP_DATA: 'load_group_data', // 一覧取得
};

const ContractorRoles = [
  USER_ROLES.prime,
  USER_ROLES.branch,
  USER_ROLES.manager,
];

const PRIVATE_COMPANY_FLAG = {
  NotPrivate: 0,
  Private: 1,
};

const PRIVATE_COMPANY_SERACH_STATE = {
  NotSet: 'NOT_SET',
  Private: 'PRIVATE',
  NotPrivate: 'NOT_PRIVATE',
};

const MAX_WORKERS_ALLOW = 200;

/**
 * @description 作業予定、作業実績一覧画面
 */
@LayoutDelegate()
export default class Works extends React.Component {
  constructor(props) {
    super(props);

    assert(['1', '2'].includes(this.props.vw));
    SessionStorageService.setSelectedBatchWorkListIds([]);
    SessionStorageService.setPrivateBatchWorkListIds([]);
    this.state = {
      sort: {},
      scheduleFlag: this.props.isWorkSchedule
        ? SCHEDULE_STATUS.schedule.id
        : SCHEDULE_STATUS.result.id,
      companyBranchId: SessionStorageService.getCompanyBranchId(),
      selected: false,
      showModal: false,
      selectedModalId: undefined,
      selectedWorkId: undefined, // ダイアログを開くときに指定している作業のID
      selectedWorkGroups: [], // ワークグループの選択状態を保持する配列
      selectedWorkIdList: [], // チェックボックスで選択状態になる作業のIDリスト
      isSelectedWorkLocked: false, // 選択した作業が自動ロックされているかどうか
      workGroups: [], // 表示しているワークグループの配列
      workTotal: 0,
      searchCount: 0, // BLDE_V2-52886: 検索結果の件数をグループから作業の件数に変更。影響範囲を狭めるために新規追加。
      searchParams: {
        schedule_flag: this.props.isWorkSchedule
          ? SCHEDULE_STATUS.schedule.id
          : SCHEDULE_STATUS.result.id,
      }, // 検索条件
      tempSearchParams: {
        schedule_flag: this.props.isWorkSchedule
          ? SCHEDULE_STATUS.schedule.id
          : SCHEDULE_STATUS.result.id,
      }, // 検索条件(保存用)
      isOpenAllGroups: false,
      reload: false, // 再読み込みフラグ
      searchMenuVisible: false,
      safetyDutyUser: [],
      safetyDutyUserName: '',
      beforeSafetyDutyUser: [],
      itemNames: { A: '', B: '', C: '', D: '' },
      displayFlg: {
        field_item_list1_display_flag: '',
        field_item_list2_display_flag: '',
        field_item_list3_display_flag: '',
        field_item_list4_display_flag: '',
      },
      options: {}, // プルダウン初期表示用データ
      loaded: false, // プルダウンの情報が取得できたか

      // TODO: 10月エンハンス向けカスタム項目設定用のstate、今は項目3のアイテム名表示のみに利用
      customColumnNames: {
        item3: '他職への注意事項',
      },
      reflectDate: '', // 実績反映用日付
      searchPrivatePartnerCompanyState: PRIVATE_COMPANY_SERACH_STATE.NotSet, //別途業者検索フラグ (NotSet: 未指定, NotPrivate: 別途業者以外, Private: 別途業者のみ)
      userFirstName: '', // ユーザ名前
      userLastName: '', // ユーザ苗字
      copyErrorMessage: null, // コピーダイアログ_エラーメッセージ
      workApprovalButtonEnabled: false,
      isLoading: true, // ロード中フラグ
      usePartnerCompanyApprovalFlag:
        SessionStorageService.getUsePartnerCompanyApprovalFlag() === API_FLAG.On, // 協力会社承認機能ご利用フラグ
      partnerApprovalName: this.props.isWorkSchedule
        ? PARTNER_APPROVAL_NAME.schedule
        : PARTNER_APPROVAL_NAME.result, // 協力会社承認機能_承認名: 受領 or 確定
      partnerApprovalWorkId: null, // 協力会社承認_対象作業ID(単数用)
      modalMessage: '', // モーダル用メッセージ
      workColumnsSettings: {
        list_order: [],
        conference_order: [],
      },
      batchEditButton: false,
      modalVisible: {
        documents: false,
      },

      displayReports: [],
      fieldId: SessionStorageService.getFieldId(),
      calling: false, // Form communication flag,
      maxRecord: MAX_WORKERS_ALLOW,
      workResultNotReflectedFlag: false,
      workReportDownloadableFlag: false,
      checkInReflectToResultFlag: false,
      approvalErrorTitle: '',
      approvalErrorMessage: '',
    };

    this.excelOutput = false; // excel出力状態
    this.pdfOutput = false; // pdf出力状態

    this.events = {
      modal: {
        handleVisible: this.handleVisible.bind(this),
        print: {
          printReport: this.printReport.bind(this),
        },
      },
    };

    this.pageName =
      this.props.isWorkSchedule === true
        ? SCHEDULE_STATUS.schedule.name
        : SCHEDULE_STATUS.result.name; // ページ名: 予定 or 実績
    this.updatingFlag = false; // 多重更新防止Flag

    // 読込処理が連続で実行された場合に並列で実行されることを防ぐ
    // 前のAPI完了後の処理と今のAPI完了後の処理が重複して不整合な表示となることを防ぐ
    this.parallelLoadGuardObj = null;
    this.newTab = null;

    this.handleOpenModalById = this.handleOpenModalById.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.setSearchParam = this.setSearchParam.bind(this);
    this.resetSearchParam = this.resetSearchParam.bind(this);
    this.handleToggleOpenAllWorkGroups = this.handleToggleOpenAllWorkGroups.bind(
      this
    );
    this.handleWorkApproval = this.handleWorkApproval.bind(this);
    this.handleSchedulesReflectOnHistories = this.handleSchedulesReflectOnHistories.bind(
      this
    );
    this.handleWorkApprovalCancelByWorkId = this.handleWorkApprovalCancelByWorkId.bind(
      this
    );
    this.handleApprovalStatusClick = this.handleApprovalStatusClick.bind(this);
    this.partnerApprovalSinglePreparation = this.partnerApprovalSinglePreparation.bind(
      this
    ); // 協力会社承認/否認 実行準備(単数用)
    this.partnerApprovalRun = this.partnerApprovalRun.bind(this); // 協力会社承認/否認 実行
    this.resetPartnerApprovalValue = this.resetPartnerApprovalValue.bind(this); // 協力会社承認_値リセット
    this.resetModalMessage = this.resetModalMessage.bind(this); // モーダル用メッセージリセット
    this.handleUpdateWorksInGroup = this.handleUpdateWorksInGroup.bind(this);

    //新規フォーム用のコールバックと値
    this.FormNew = {
      callback: {
        submit: () => {
          console.log('Submit');
        },
      },
      //何か渡したいとき
      state: {},
    };

    EventMg.registerEvent(MY_EVENT.LOAD_GROUP_DATA);
    EventMg.addEventListener(MY_EVENT.LOAD_GROUP_DATA, isBack => {
      if (!isBack) {
        this.setState({ reload: true });
      }
    });

    // メモ化用
    this.workGroupsPartitionParamMemo = null;
    this.workGroupsPartitionResultMemo = null;

    // 検索条件初期化
    FieldService.fieldItem(SessionStorageService.getFieldId()).then(resp => {
      if (!resp || resp.result === false) {
        return;
      }
      const displayFlg = this.state.displayFlg;
      const item_list_ids = [1, 2, 3, 4];
      const field_item = resp.data.entities.field_item;
      _.each(displayFlg, (value, key) => {
        displayFlg[key] = field_item[key];
      });
      FieldService.workColumnsSettings(SessionStorageService.getFieldId(), {
        schedule_flag: this.props.isWorkSchedule
          ? WORK_TYPE.WORK_SCHEDULE.SCHEDULE_FLAG
          : WORK_TYPE.WORK_RESULT.SCHEDULE_FLAG,
      }).then(response => {
        if (response.result) {
          const batchEditTypes = _.map(
            _.filter(
              response.data.entities.work_columns_settings.edit_multiple_order,
              item => {
                if (_.includes(this.optionListNumbers, item.type)) {
                  return (
                    item.display === true &&
                    field_item[`${item.type}_display_flag`] === API_FLAG.On
                  );
                }
                return item.display === true;
              }
            ),
            item => {
              return item.type;
            }
          );
          this.setState({ batchEditButton: !_.isEmpty(batchEditTypes) });
        }
      });
      _.map(item_list_ids, (itemListId, key) => {
        if (field_item[`field_item_list${itemListId}_display_flag`] === 0) {
          item_list_ids.splice(key, 1);
        }
      });

      if (item_list_ids.length > 0) {
        const params = {
          item_list_ids,
          is_limit: 1,
          offset: 0,
          limit: 30,
          // 有効のものだけ表示
          display_flag: 1,
        };
        // 現場作業エリア情報取得API
        FieldItemService.list(SessionStorageService.getFieldId(), params).then(
          response => {
            if (response.result === false) {
              return;
            }
            this.setState({
              options: response.data.entities,
              loaded: true,
            });
          }
        );
      }
    });
    this.approvedListIds = [];
    this.unapprovedListIds = [];
    this.partnerApprovalListsIds = [];
    this.partnerUnapprovalListsIds = [];
    this.workSuspendedListsIds = [];
    this.workIds = [];
    this.fromDate = SessionStorageService.getFromDate();
    this.toDate = SessionStorageService.getToDate();
    this.optionListNumbers = _.times(20, i => `option${i + 1}`);
  }

  async componentDidMount() {
    // // BLDE_V2-16058 画面遷移不具合のために eruda 導入
    // eruda.init();

    const currentDate = SessionStorageService.getFromDate();
    UserProfileService.show(LocalStorageService.getUserId(), {}).then(
      response => {
        if (response.result === false) {
          return;
        }
        const userProfile = response.data.entities.user_profile;
        const firstName = userProfile.name_mei;
        const lastName = userProfile.name_sei;
        this.setState({ userFirstName: firstName, userLastName: lastName });
      }
    );

    // 安全当番データ取得
    Promise.all([
      SafetyDutyService.select(
        SessionStorageService.getFieldId(),
        currentDate,
        SessionStorageService.getWorkHourZone()
      ),
      FieldItemInputsService.itemNames(SessionStorageService.getFieldId()),
      FieldService.workColumnsSettings(SessionStorageService.getFieldId(), {
        schedule_flag: this.props.isWorkSchedule
          ? WORK_TYPE.WORK_SCHEDULE.SCHEDULE_FLAG
          : WORK_TYPE.WORK_RESULT.SCHEDULE_FLAG,
      }),
    ]).then(responses => {
      const [
        selectResponse,
        itemNamesResponse,
        // companyItemResponse,
        workColumnsSettingsResponse,
      ] = responses;
      const list_order = _.sortBy(
        _.filter(
          workColumnsSettingsResponse.data.entities.work_columns_settings
            .list_order,
          item => {
            return item.display === true;
          }
        ),
        item => {
          return item.order_number;
        }
      );
      const conference_order = _.sortBy(
        _.filter(
          workColumnsSettingsResponse.data.entities.work_columns_settings
            .conference_order,
          item => {
            return item.display === true;
          }
        ),
        item => {
          return item.order_number;
        }
      );

      let state = {
        itemNames: itemNamesResponse,
        workColumnsSettings: {
          list_order,
          conference_order,
        },
      };

      if (!_.isEmpty(selectResponse.data.entities.safety_duty)) {
        state = {
          ...state,
          safetyDutyUser: [
            String(selectResponse.data.entities.safety_duty.user_id),
          ],
          safetyDutyUserName:
            selectResponse.data.entities.safety_duty.user_name,
        };
      }
      this.setState(state);
    });

    this.loadGroupData(() => {
      return;
    });

    // 実績に反映ダイアログ用日付取得
    let reflectDate;
    if (
      moment(SessionStorageService.getFromDate(), 'YYYY/MM/DD').diff(
        moment(SessionStorageService.getToDate(), 'YYYY/MM/DD'),
        'day'
      ) !== 0
    ) {
      reflectDate = `${moment(
        SessionStorageService.getFromDate(),
        'YYYY/MM/DD'
      ).format('MM/DD')}-${moment(
        SessionStorageService.getToDate(),
        'YYYY/MM/DD'
      ).format('MM/DD')}`;
    } else {
      reflectDate = moment(
        SessionStorageService.getFromDate(),
        'YYYY/MM/DD'
      ).format('MM/DD');
    }

    const workApprovalButtonEnabled = await this.isVisibleWorkApprovalControl(
      SessionStorageService.getFieldId()
    );

    this.setState({ reflectDate, workApprovalButtonEnabled });

    this.getReportsInformation();

    await FieldService.info(SessionStorageService.getFieldId(), {}).then(
      response => {
        if (response.result) {
          const field = _.get(response, 'data.entities.field');
          this.setState({
            checkInReflectToResultFlag:
              _.get(field, 'use_check_in_reflect_to_result_flag') &&
              moment().isAfter(
                _.get(field, 'use_check_in_reflect_to_result_start_date'),
                'day'
              ),
            workReportDownloadableFlag: _.get(
              field,
              'work_report_downloadable_flag'
            ),
          });
        }
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.searchParams !== this.state.searchParams) {
      const searchPrivatePartnerCompanyState = this.detectPivatePartnerCompanyFlagInSearchParams();
      this.resetResult();
      this.setState(
        {
          searchPrivatePartnerCompanyState,
          workGroups: [],
          workTotal: 0,
          isLoading: true,
        },
        () => {
          this.loadGroupData(() => {});
        }
      );
    } else if (prevState.reload !== this.state.reload) {
      if (this.state.reload) {
        this.resetResult();
        this.reLoadGroupData();
        EventManager.trigger(EventType.REFRESH_UNAPPROVED_WORKS_COUNT);
      }
    }
  }

  resetListsValues = () => {
    this.approvedListIds = [];
    this.unapprovedListIds = [];
    this.partnerApprovalListsIds = [];
    this.partnerUnapprovalListsIds = [];
    this.workSuspendedListsIds = [];
    this.workIds = [];
  };

  updateApproveUnapprovedList = () => {
    this.resetListsValues();
    _.each(this.state.workGroups, workGroup => {
      if (!_.isEmpty(workGroup.works)) {
        _.each(workGroup.works, work => {
          this.workIds.push(work.id);
          const workSuspended = work.state_handling_flag === API_FLAG.On;
          if (!workSuspended) {
            if (work.approved_num > 0 || work.auto_lock_flg === API_FLAG.On) {
              this.approvedListIds.push(work.id);
            } else {
              this.unapprovedListIds.push(work.id);
            }
            if (work.partner_company_approval_flag === API_FLAG.Off) {
              this.partnerUnapprovalListsIds.push(work.id);
            } else {
              this.partnerApprovalListsIds.push(work.id);
            }
          } else {
            this.workSuspendedListsIds.push(work.id);
          }
        });
      }
    });
  };
  /**
   * 検索パラメータにprivate_partner_company_flagが存在するかどうかによってsearchPrivatePartnerCompanyStateを差し替える
   *  */
  detectPivatePartnerCompanyFlagInSearchParams = () => {
    if (_.has(this.state.searchParams, 'private_partner_company_flag')) {
      return Number(this.state.searchParams.private_partner_company_flag) ===
        PRIVATE_COMPANY_FLAG.Private
        ? PRIVATE_COMPANY_SERACH_STATE.Private
        : PRIVATE_COMPANY_SERACH_STATE.NotPrivate;
    }
    return PRIVATE_COMPANY_SERACH_STATE.NotSet;
  };

  concatWorkGroupLoadMore = (currentWorkGroups, loadedGroups) => {
    const currentCount = _.size(currentWorkGroups) - 1;
    const reflectedTotalShowKeys = ['field_tree_id', 'work_date'];
    let preWorkGroup =
      currentCount > 0 ? currentWorkGroups[currentCount - 1] : {};

    _.forEach(loadedGroups, group => {
      const conditionsForNotShow = _.pick(preWorkGroup, reflectedTotalShowKeys);
      group.isShowReflectedWorkTotal = !_.isEqual(
        _.pick(group, reflectedTotalShowKeys),
        conditionsForNotShow
      );
      preWorkGroup = group;
    });

    return _.concat(currentWorkGroups, loadedGroups);
  };

  // 作業グループ情報の取得
  async loadGroupData(notify) {
    if (this.state.reload) {
      // リロード中は実行しない
      this.setState({ isLoading: false });
      return;
    }
    this.parallelLoadGuardObj = {};
    const selfGuardObj = this.parallelLoadGuardObj;

    this.setState({
      isLoading: true,
    });

    const { workGroups } = this.state;
    const {
      items: loadedGroups,
      totalCount: groupTotal,
      searchCount,
      workResultNotReflectedFlag,
    } = await this.loadWorkGroups(workGroups.length);

    await this.loadWorkInWorkGroups(loadedGroups);

    // 連続で実行された場合に最後に呼ばれた処理のみ反映する
    if (selfGuardObj !== this.parallelLoadGuardObj) {
      return;
    }

    this.setState(
      {
        workGroups: this.concatWorkGroupLoadMore(workGroups, loadedGroups),
        workTotal: groupTotal,
        searchCount: searchCount,
        isLoading: false,
        workResultNotReflectedFlag,
      },
      () => {
        this.updateApproveUnapprovedList();
        notify();
      }
    );
  }

  addLoadGroupData = async notify => {
    // 追加読込の場合はisLoadingを見て連続で呼ばれないようにする
    if (this.state.isLoading) {
      return;
    }
    this.setState({ isLoading: true });
    await this.loadGroupData(notify);
  };

  // 作業グループ情報の再取得
  async reLoadGroupData(callback) {
    const loadedMaxCount = this.state.workGroups.length;
    const {
      allItems,
      totalCount,
      workResultNotReflectedFlag,
      searchCount,
    } = await ReloadHelper.takeLoad(
      this.loadWorkGroupsAndWorksFirstPage,
      loadedMaxCount,
      loadedMaxCount === this.state.workTotal
    );

    // 「さらに表示する」で追加された分を追加
    const workGroups = await this.reloadWorkInWorkGroups(allItems);

    this.setState({
      workGroups: this.concatWorkGroupLoadMore([], workGroups),
      workTotal: totalCount,
      searchCount: searchCount,
      workResultNotReflectedFlag,
    });
    this.setState({ reload: false }, () => {
      this.updateApproveUnapprovedList();
      callback && callback();
    });
  }

  /**
   * 作業グループ複数の情報の取得
   */
  loadWorkGroups = async offset => {
    const work_hour_zones = [SessionStorageService.getWorkHourZone()];
    let params = {
      ...this.mergeDateParameter(this.state.searchParams),
      work_hour_zones,
      offset,
    };
    params = _.omit(params, 'work_hour_zone');
    const response = await WorkScheduleService.mainSchedules(
      SessionStorageService.getFieldId(),
      params
    );
    if (response.result) {
      return {
        items: response.data.entities.work_groups,
        totalCount: response.data.total,
        searchCount: response.data.total_work,
        workResultNotReflectedFlag: response.data.reflected_work_flag,
      };
    } else {
      return {
        items: [],
        totalCount: 0,
        searchCount: 0,
      };
    }
  };

  // WorkGroupsとWorksの最初のページ(10件)を取得
  loadWorkGroupsAndWorksFirstPage = async offset => {
    const {
      items: loadedGroups,
      totalCount: groupTotal,
      searchCount,
      workResultNotReflectedFlag,
    } = await this.loadWorkGroups(offset);

    await this.loadWorkInWorkGroups(loadedGroups);

    return {
      items: loadedGroups,
      totalCount: groupTotal,
      searchCount: searchCount,
      workResultNotReflectedFlag,
    };
  };

  worksConvert = (items, itemParent) => {
    // BLDE_V2-16558 旧APIのデータ形式にあわせてデータを作る
    // そうしないとフロント側のどこで情報を読み取っているか不明なため
    items.forEach(item => {
      item.company_name = itemParent.company_name;
      item.company_name_1 = itemParent.company_name_1;
      item.field_id = itemParent.field_id;
      item.field_tree_id = itemParent.field_tree_id;
      item.foreman_user_id = itemParent.foreman_user_id;
      item.foreman_user_name_mei = itemParent.foreman_user_name_mei;
      item.foreman_user_name_sei = itemParent.foreman_user_name_sei;
      item.job_id = itemParent.job_id;
      item.job_name = itemParent.job_name;
      item.should_approved_num = itemParent.should_approved_num;
      item.work_date = itemParent.work_date;
    });

    return items;
  };

  /**
   * 初期表示時
   * ワークグループ複数の内部のワーク情報を取得する
   */
  loadWorkInWorkGroups = async workGroups => {
    if (!_.isArray(workGroups)) {
      return;
    }
    if (workGroups.length === 0) {
      return;
    }

    // 初期起動時には ワークグループIDを複数指定して同時にデータを取得する
    const params = { ...this.state.searchParams };
    // ワークグループ複数のIDを配列にする
    params.work_group_ids = workGroups.map(workGroup => workGroup.id);
    params.limit = LIST_LIMIT.WORK.CHILD;

    const data = await fetchMg
      .GetAjax(
        `/api/private/fields/${SessionStorageService.getFieldId()}/works/list`,
        params
      )
      .catch(() => ({ result: false }));
    if (!data.result) {
      return;
    }
    // console.log('Works.jsx loadWorkInWorkGroups', data, params);

    // 取得したデータをワークグループでループして内部の値を更新する
    for (let workGroup of workGroups) {
      const responseWorkGroup = data.data.entities.works.find(
        responseWorkGroupItem => {
          return responseWorkGroupItem.work_group_id === workGroup.id;
        }
      );
      if (_.isUndefined(responseWorkGroup)) {
        continue;
      }

      const itemParent = responseWorkGroup;
      const items = this.worksConvert(itemParent.work_list, itemParent);
      workGroup.works = items;
      workGroup.worksLoadComp = items.length === itemParent.works_total;
      workGroup.totalSumHours = itemParent.total_sum_hours;
    }
  };

  /**
   * ワークグループ単独の情報を取得する
   */
  loadWorksUnit = async ({
    fieldId,
    workGroupId,
    searchParams,
    offset,
    limit = LIST_LIMIT.WORK.CHILD,
  }) => {
    // console.log('Works.jsx loadWorksUnit');
    if (match(workGroupId, [null, undefined, ''])) {
      return {
        items: [],
        totalCount: 0,
        totalSumHours: '0.0',
      };
    }
    let params = {};
    params.work_group_ids = [workGroupId];
    if (!_.isUndefined(searchParams)) {
      params = { ...params, ...searchParams };
    }
    if (!_.isUndefined(offset)) {
      params.offset = offset;
    }
    params.limit = limit;

    const data = await fetchMg
      .GetAjax(`/api/private/fields/${fieldId}/works/list`, params)
      .catch(() => ({ result: false }));
    if (!data.result) {
      return {
        items: [],
        totalCount: 0,
        totalSumHours: '0.0',
      };
    }

    const itemParent = data.data.entities.works[0];
    const items = this.worksConvert(itemParent.work_list, itemParent);

    return {
      items,
      totalCount: itemParent.works_total,
      totalSumHours: itemParent.total_sum_hours,
    };
  };

  /**
   * ワークグループ単独の内容を前回値に従って読み込む
   * 既存が30件のデータの場合、新しく読み込む場合も10件x3で読み込む
   */
  reloadWorks = async (prevWorkGroup, nextWorkGroup) => {
    // 既に読込済みの場合は何もしない
    if (
      // グループ内で1件目のWorkを作成した場合はprevWorkGroupはundefined
      !prevWorkGroup ||
      // 完了済みの場合は追加なし
      nextWorkGroup.worksLoadComp ||
      // 10件以上存在するが「さらに表示する」を1回も押していない場合は同じになる
      // 総件数が同じではなくて表示した件数が10件=10件の確認
      (!prevWorkGroup.worksLoadComp &&
        _.size(prevWorkGroup.works) === _.size(nextWorkGroup.works))
    ) {
      return nextWorkGroup;
    }

    const loadedMaxCount = _.size(prevWorkGroup.works);
    const { allItems, totalCount, totalSumHours } = await ReloadHelper.takeLoad(
      (offset, limit) =>
        this.loadWorksUnit({
          fieldId: SessionStorageService.getFieldId(),
          workGroupId: prevWorkGroup.id,
          searchParams: this.state.searchParams,
          offset,
          limit,
        }),
      loadedMaxCount,
      prevWorkGroup.worksLoadComp,
      _.size(nextWorkGroup.works), //既に読込済みなので開始位置を指定
      LIST_LIMIT.WORK.CHILD
    );

    //読込済みのworksと追加で取得したworksを結合
    const nextWorks = nextWorkGroup.works.concat(allItems);
    const result = {
      ...nextWorkGroup,
      works: nextWorks,
      worksLoadComp: nextWorks.length === totalCount,
    };
    if (!_.isUndefined(totalSumHours)) {
      result.totalSumHours = totalSumHours;
    }
    return result;
  };

  reloadWorkInWorkGroups = async workGroups => {
    return await Promise.all(
      _.map(workGroups, async nextWorkGroup => {
        const prevWorkGroup = _.find(
          this.state.workGroups,
          workGroup => workGroup.id === nextWorkGroup.id
        );
        return await this.reloadWorks(prevWorkGroup, nextWorkGroup);
      })
    );
  };

  // 検索結果のリセット
  resetResult() {
    this.setState({
      selectedWorkIdList: [],
      selectedWorkGroups: [],
    });
  }

  /**
   * @description オープンするモーダルIDを設定
   * @param {string} modalId モーダルID(modalList)
   */
  handleOpenModalById = (modalId, message = '') => {
    this.setState({ selectedModalId: modalId, showModal: true, message });
  };

  // 画面上に存在する作業を全て選択/選択解除
  handleSelectAll = isSelected => {
    const { workGroups } = this.state;

    // グループチェックボックス
    let selectedWorkGroups = [];
    let selectedWorkIdList = [];
    if (isSelected) {
      selectedWorkGroups = _.map(workGroups, workGroup => workGroup.id);
      // ワークグループ内項目
      workGroups.forEach(workGroup => {
        workGroup.works.forEach(work => {
          selectedWorkIdList.push(work.id);
        });
      });
    }

    this.setState(
      {
        selectedWorkGroups,
        selectedWorkIdList,
      },
      () => this.updateApproveUnapprovedList()
    );
  };

  // 作業を選択(1件)
  handleWorkSelect(workId) {
    const selectedWorkIdList = [...this.state.selectedWorkIdList];
    const workIdIndex = selectedWorkIdList.indexOf(workId);
    const select = workIdIndex === -1;
    if (select) {
      // 選択リストに入っていなければ選択
      selectedWorkIdList.push(workId);
    } else {
      // 選択リストに入っていれば選択解除
      selectedWorkIdList.splice(workIdIndex, 1);
    }

    this.updateWorkGroupSelect(workId, select, selectedWorkIdList);

    this.setState({ selectedWorkIdList }, () => {
      this.updateApproveUnapprovedList();
    });
  }

  /**
   * ワーク選択時にワークグループの選択状態を切り替える処理
   */
  updateWorkGroupSelect(workId, select, selectedWorkIdList) {
    const selectedWorkGroups = [...this.state.selectedWorkGroups];

    // 項目選択時にグループ項目の選択を切り替える
    // workId が所属しているworkGroupを求める
    const workGroup = this.state.workGroups.find(
      workGroup =>
        !_.isUndefined(workGroup.works.find(work => work.id === workId))
    );
    // そのworkGroupが、選択されているかどうかをIndexで判定する
    const workGroupIndex = selectedWorkGroups.findIndex(
      id => id === workGroup.id
    );
    if (select) {
      if (workGroup.works.every(work => selectedWorkIdList.includes(work.id))) {
        // ワークグループ内の全項目が選択されている場合
        if (workGroupIndex === -1) {
          selectedWorkGroups.push(workGroup.id);
          this.setState({ selectedWorkGroups });
          return;
        }
      }
    } else {
      if (workGroupIndex !== -1) {
        selectedWorkGroups.splice(workGroupIndex, 1);
        this.setState({ selectedWorkGroups });
        return;
      }
    }
  }

  // グループを選択
  handleGroupSelect = (groupId, privatePartnerCompanyFlag, isSelected) => {
    const { selectedWorkIdList, selectedWorkGroups, workGroups } = this.state;

    // group
    const targetGroup = _.find(workGroups, workGroup => {
      return workGroup.id === groupId;
    });
    if (!targetGroup) {
      return;
    }

    let newSelectedWorkGroups;
    if (isSelected) {
      if (!_.includes(selectedWorkGroups, targetGroup.id)) {
        newSelectedWorkGroups = _.concat(selectedWorkGroups, targetGroup.id);
      }
    } else {
      if (_.includes(selectedWorkGroups, targetGroup.id)) {
        newSelectedWorkGroups = _.pullAll(selectedWorkGroups, [targetGroup.id]);
      }
    }

    // ワークグループ内項目
    if (isSelected) {
      workGroups.forEach(workGroup => {
        if (workGroup.id === groupId) {
          workGroup.works.forEach(work => {
            if (!selectedWorkIdList.includes(work.id)) {
              selectedWorkIdList.push(work.id);
            }
          });
        }
      });
    } else {
      workGroups.forEach(workGroup => {
        if (workGroup.id === groupId) {
          workGroup.works.forEach(work => {
            const index = selectedWorkIdList.indexOf(work.id);
            if (index !== -1) {
              selectedWorkIdList.splice(index, 1);
            }
          });
        }
      });
    }

    this.setState({
      selectedWorkIdList,
      selectedWorkGroups: newSelectedWorkGroups,
    });
  };

  /**
   * スクロールグループの「さらに表示」でデータが追加された時のイベント
   */
  handleUpdateWorksInGroup({ workGroupId, works, worksLoadComp }) {
    const stateWorkGroups = _.cloneDeep(this.state.workGroups);
    const targetGroup = _.find(stateWorkGroups, workGroup => {
      return workGroup.id === workGroupId;
    });

    targetGroup.works = works;
    targetGroup.worksLoadComp = worksLoadComp;

    // ワークグループの選択状態を解除する
    const selectedWorkGroups = [...this.state.selectedWorkGroups];
    const workGroupIndex = selectedWorkGroups.findIndex(
      id => id === workGroupId
    );
    if (workGroupIndex !== -1) {
      selectedWorkGroups.splice(workGroupIndex, 1);
    }

    this.setState({
      workGroups: stateWorkGroups,
      selectedWorkGroups,
    });
  }

  /**
   * Get report information (reportData):
   *  report.id
   *  report.report_code
   *  report.report_name
   *  report.printout_excel_flag
   *  report.printout_pdf_flag
   *  ...
   */
  getReportsInformation() {
    const param = {
      field_id: this.state.fieldId,
      is_work_schedule: this.props.isWorkSchedule
        ? WORK_TYPE.WORK_SCHEDULE.SCHEDULE_FLAG
        : WORK_TYPE.WORK_RESULT.SCHEDULE_FLAG,
    };

    ReportSettingService.list(param).then(resp => {
      if (resp.result) {
        const reportSettings = resp.data.entities.report_settings;

        if (reportSettings && reportSettings.length > 0) {
          this.setState({
            displayReports: reportSettings,
          });
        }
      }
    });
  }

  /***
   * ダイアログ表示・非表示
   * @params key {string}
   */
  handleVisible = (key, approvalMessage) => {
    const modalState = {};
    const visible = !this.state.modalVisible[key];
    modalState[key] = visible;
    if (key === 'disableTime' || key === 'success') {
      this.getDisabledTimes();
    }
    if (!_.isUndefined(approvalMessage)) {
      if (approvalMessage === '') {
        modalState[key] = !visible;
      } else {
        modalState['approvalMessage'] = approvalMessage;
      }
    }
    this.setState({
      message: '',
      modalVisible: modalState,
      passage_date: moment().format('YYYY/MM/DD'),
      deleteScheduleLimitTimeIds: [],
    });
  };

  /***
   * Handle when click to Print button
   * Behavior after button click:
   *  If the number of reports > 1, regardless printout_x_flag                                         ==> display the dialog
   *  If the number of reports == 1, printout_excel_flag and printout_pdf_flag are turn on             ==> display the dialog
   *  If the number of reports == 1, printout_excel_flag is turn on and printout_pdf_flag is turn off  ==> export the report with Excel type instantly
   *  If the number of reports == 1, printout_excel_flag is turn off and printout_pdf_flag is turn on  ==> export the report with PDF type instantly
   *  If the number of reports == 1, printout_excel_flag and printout_pdf_flag are turn off            ==> display error dialog
   *  If the number of reports == 0                                                                    ==> display error dialog
   */
  handlePrintOutClicked() {
    // default behavior: display the dialog
    let clickedBehavior =
      PRINTOUT_BUTTON_CLICK_BEHAVIOR.displayListReportsDialog;
    let reportData;

    if (!this.state.displayReports || this.state.displayReports.length === 0) {
      clickedBehavior = PRINTOUT_BUTTON_CLICK_BEHAVIOR.displayErrorDialog;
    } else if (this.state.displayReports.length === 1) {
      reportData = this.state.displayReports[0];
      if (!reportData.printout_excel_flag && !reportData.printout_pdf_flag) {
        clickedBehavior = PRINTOUT_BUTTON_CLICK_BEHAVIOR.displayErrorDialog;
      } else if (
        reportData.printout_excel_flag &&
        !reportData.printout_pdf_flag
      ) {
        clickedBehavior = PRINTOUT_BUTTON_CLICK_BEHAVIOR.printExcel;
      } else if (
        !reportData.printout_excel_flag &&
        reportData.printout_pdf_flag
      ) {
        clickedBehavior = PRINTOUT_BUTTON_CLICK_BEHAVIOR.printPDF;
      }
    }

    switch (clickedBehavior) {
      case PRINTOUT_BUTTON_CLICK_BEHAVIOR.printExcel:
        this.printReport(reportData, false);
        break;
      case PRINTOUT_BUTTON_CLICK_BEHAVIOR.printPDF:
        this.printReport(reportData, true);
        break;
      case PRINTOUT_BUTTON_CLICK_BEHAVIOR.displayListReportsDialog:
        this.handleOpenModalById(modalList.WorkListReports);
        break;
      default:
        // PRINTOUT_BUTTON_CLICK_BEHAVIOR.displayErrorDialog
        this.showErrorScreenDialog(
          messageUtility.getMessage('E-001-413'),
          messageUtility.getMessage('I-000-017')
        );
        break;
    }
  }

  /**
   * Handle Printout reports
   * @param {report_settings} reportData
   * @param {Boolean} is_pdf
   * @returns
   */
  printReport = (reportData, is_pdf) => {
    const reportInformation = ReportLists.find(
      report => report.id == reportData.id
    );
    if (!reportInformation) {
      return;
    }

    const param = { ...this.state.searchParams };
    param.field_id = SessionStorageService.getFieldId();
    param.work_hour_zone = SessionStorageService.getWorkHourZone();
    param.target_date = moment(SessionStorageService.getFromDate()).format(
      'YYYY-MM-DD'
    );
    param.file_code = is_pdf ? FILE_CODE.PDF : FILE_CODE.EXCEL;
    param.report_code = reportData.report_code;

    // Add these parameters if user roles is partner or foreman
    if (isLoginUserPartner() || isLoginUserForeman()) {
      param.foreman_user_id = LocalStorageService.getUserId();
      param.is_foreman_print = 1;
    }

    const reportName = reportInformation.name;

    if (param.file_code == FILE_CODE.EXCEL) {
      return this.exportExcel(reportName, param);
    } else if (param.file_code == FILE_CODE.PDF) {
      return this.exportPdf(reportName, param, true);
    }
  };

  /**
   * Export report to EXCEL
   * @param {String} reportName
   * @param {Array} param
   * @returns
   */
  exportExcel(reportName, param) {
    if (this.excelOutput) {
      return;
    }

    this.excelOutput = true;

    return PrintService.printReportByReportNameForList(reportName, param)
      .then(async blob => {
        let response;
        if (blob instanceof Blob) {
          response = await blobToJsonConversion(blob);
        } else {
          response = blob;
        }

        if (
          !PrintService.handleShowErrorDialogForList(response, errorMessage => {
            if (_.isEqual(response.status, STATUS_CODE.badRequest)) {
              return this.handleOpenModalById(
                modalList.WorkReportDownloadError
              );
            }
            this.showErrorScreenDialog(
              errorMessage,
              messageUtility.getMessage('I-000-017')
            );
          })
        ) {
          const fileName = PrintService.makeReportFileName(
            reportName,
            param.file_code,
            param.target_date
          );
          PrintUtility.printBlob(blob, fileName);
        } else {
          // Close if there are error dialog
          this.handleCloseModal();
        }
      })
      .finally(() => {
        this.excelOutput = false;
      });
  }

  /**
   * Export report to PDF
   * @param {String} reportName
   * @param {Array} param
   * @param {Boolean} isOpenNewTab
   * @returns
   */
  exportPdf(reportName, param, isOpenNewTab = false) {
    if (this.pdfOutput) {
      return;
    }

    this.pdfOutput = true;

    if (isOpenNewTab) {
      this.newTab = window.open('/LayoutPrint', '_blank');
    }

    return PrintService.printReportByReportNameForList(reportName, param)
      .then(async response => {
        if (
          !PrintService.handleShowErrorDialogForList(response, errorMessage => {
            if (this.newTab) {
              this.newTab.close();
            }
            if (_.isEqual(response.status, STATUS_CODE.badRequest)) {
              return this.handleOpenModalById(
                modalList.WorkReportDownloadError
              );
            }
            this.showErrorScreenDialog(
              errorMessage,
              messageUtility.getMessage('I-000-017')
            );
          })
        ) {
          // We need to use the 2nd then() to make newTab can be opened before exporting PDF
          return response;
        } else {
          // Close if there are error dialog
          this.handleCloseModal();
          // Reject to ignore the 2nd then()
          await Promise.reject();
        }
      })
      .then(async response => {
        const fileName = PrintService.makeReportFileName(
          reportName,
          param.file_code,
          param.target_date
        );
        let blob;
        if (_.isUndefined(response.message)) {
          const pdfUrl = response.pdf_s3_url;
          await PrintService.getHeaderReponseURL(pdfUrl.head_pdf_url)
            .then(responseS3AWS => {
              if (responseS3AWS.status === STATUS_CODE.ok) {
                blob = PrintUtility.convertBase64ToBlob(
                  response.data,
                  'application/pdf'
                );
                if (this.newTab) {
                  this.newTab.location.href = pdfUrl.get_pdf_url;
                }
              }
            })
            .catch(error => {
              if (this.newTab) {
                this.newTab.close();
              }
              let result = {
                result: false,
                status: error.status,
                message: messageUtility.getMessage('E-001-401'),
              };
              blob = new Blob([JSON.stringify(result)], {
                type: 'application/json',
              });
            });
        } else {
          if (this.newTab) {
            this.newTab.close();
          }
          blob = new Blob([JSON.stringify(response)], {
            type: 'application/json',
          });
        }
        PrintUtility.printBlob(blob, fileName, param.file_code);
      })
      .finally(() => {
        this.pdfOutput = false;
      });
  }

  handleToggleOpenAllWorkGroups = isOpened => () => {
    this.setState({ isOpenAllGroups: isOpened });
  };

  // 安全当番ドロップダウン選択 期間選択(複数日付)
  handleKikanModal = user_id => {
    this.setState({
      beforeSafetyDutyUser: this.state.safetyDutyUser,
      safetyDutyUser: _.isNull(user_id) ? [] : [user_id],
    });
    this.handleOpenModalById(modalList.Kikan);
  };

  /**
   * @description モーダルIDが設定されていた場合、該当モーダルを画面に表示
   * @param {string} modalId モーダルID(modalList)
   */
  setModalById = modalId => {
    switch (modalId) {
      case modalList.ManHour:
        return this.props.isWorkSchedule ? (
          <WorkScheduleManHours
            mergedSearchParams={this.mergeDateParameter(
              this.state.searchParams
            )}
            onClose={this.handleCloseModal}
            fieldId={SessionStorageService.getFieldId()}
          />
        ) : (
          <WorkResultManHours
            mergedSearchParams={this.mergeDateParameter(
              this.state.searchParams
            )}
            onClose={this.handleCloseModal}
            fieldId={SessionStorageService.getFieldId()}
          />
        );
      case modalList.ManHourInput:
        return (
          <WorkHourModal
            onUpdate={this.onManHourChanged}
            onClose={this.handleCloseModal}
            workId={this.state.selectedWorkId}
            scheduleFlag={this.state.scheduleFlag}
          />
        );
      case modalList.ApprovalStatus:
        return (
          <WorkApproval
            onClose={this.handleCloseModal}
            onCancelWorkApproval={this.handleWorkApprovalCancelByWorkId}
            workId={this.state.selectedWorkId}
            fieldId={SessionStorageService.getFieldId()}
            workApprovalButtonEnabled={this.state.workApprovalButtonEnabled}
            autoLock={this.state.isSelectedWorkLocked}
            onApproved={this.onApprovalChanged}
            onShowDialogDeniedApproval={
              this.handleVisibleApprovalWorksErrorModal
            }
          />
        );
      case modalList.CopyWorks:
        return (
          <CopyWorks
            copyErrorMessage={this.state.copyErrorMessage}
            onClose={() => this.handleCloseModal()}
            onCopy={date =>
              this.handleCopyWorkSchedule(this.state.selectedWorkIdList, date)
            }
          />
        );
      case modalList.WorkListReports:
        return (
          <WorkListReports
            reportData={this.state.displayReports}
            onPrint={this.events.modal.print.printReport}
            onClose={this.handleCloseModal}
          />
        );
      case modalList.Kikan:
        return (
          <SafetyDutyModal
            onSave={() => this.handleUpdateKikanSafetyDuties()}
            onClose={() => this.rollbackSafetyDutyUser()}
          />
        );
      case modalList.CheckInNotReflectWorksDialog: {
        return (
          <CheckInNotReflectWorksDialog
            fieldId={this.state.fieldId}
            fromDate={this.fromDate}
            toDate={this.toDate}
            onClose={this.handleCloseModal}
          />
        );
      }
      default:
        return null;
    }
  };

  /**
   * @description 選択作業を承認
   * @param {string} fieldId 現場ID
   * @param {array} selectedWorkIdList 選択作業リスト
   */
  handleWorkApproval = onceAsyncRequest(async (fieldId, selectedWorkIdList) => {
    await UserProfileService.show(LocalStorageService.getUserId(), {}).then(
      async response => {
        if (response.result === false) {
          return;
        }
        const userProfile = response.data.entities.user_profile;
        const firstName = userProfile.name_mei; // ユーザの名前
        const lastName = userProfile.name_sei; // ユーザの苗字
        await WorkApprovalService.workApproval(
          fieldId,
          selectedWorkIdList,
          firstName,
          lastName,
          true
        ).then(response => {
          const errorCode = _.get(response, 'data.data.entities.error_code');
          if (errorCode) {
            this.handleCloseModal();
            this.onApprovalChanged();
            return this.handleVisibleApprovalWorksErrorModal(
              messageUtility.getMessage('E-001-440'),
              messageUtility.getMessage(errorCode)
            );
          }
          if (response.result === false) {
            return;
          }
          if (_.get(response, 'data.entities.is_over_limit_approval')) {
            modalList.DynamicSuccessTitle = messageUtility.getMessage(
              'E-001-455'
            );
            modalList.DynamicSuccessMessage = messageUtility.getMessage(
              'E-001-456'
            );
            this.handleOpenModalById(modalList.DynamicSuccess);
          } else if (_.has(response, 'message') && response.message === '') {
            this.handleCloseModal();
          } else if (!_.isUndefined(response.message)) {
            // 承認/承認解除結果ダイヤログのタイトル
            const approvalTitle = `作業${this.pageName}の承認${
              response.message.includes('完了') ? '完了' : ''
            }`;
            modalList.DynamicSuccessTitle = approvalTitle;
            modalList.DynamicSuccessMessage = response.message;
            this.handleOpenModalById(modalList.DynamicSuccess);
          }
          this.onApprovalChanged();
        });
      }
    );
  });

  /**
   * 「選択項目を承認」「選択項目の承認解除」ボタンの表示非表示
   */
  async isVisibleWorkApprovalControl(fieldId) {
    let result = true;

    // console.log('Works.jsx isVisibleWorkApprovalControl');
    await WorkApprovalService.list(fieldId, '0').then(response => {
      // console.log('Works.jsx isVisibleWorkApprovalControl response', response);
      if (!response.result) {
        return;
      }
      const workApprovals = response.data.entities.work_approvals;

      result = _.some(workApprovals, workApproval => {
        return workApproval.is_operatable !== false;
      });
    });

    return result;
  }

  // 作業承認解除
  handleWorkApprovalCancel = onceAsyncRequest(
    async (fieldId, selectedWorkIdList) => {
      await WorkApprovalService.cancelWorkApproval(
        fieldId,
        selectedWorkIdList
      ).then(response => {
        if (response.result === false) {
          return;
        }

        if (_.get(response, 'data.entities.is_over_limit_approval')) {
          modalList.DynamicSuccessTitle = messageUtility.getMessage(
            'E-001-457'
          );
          modalList.DynamicSuccessMessage = messageUtility.getMessage(
            'E-001-458'
          );
          this.handleOpenModalById(modalList.DynamicSuccess);
        } else if (_.has(response, 'message') && response.message === '') {
          this.handleCloseModal();
        } else if (!_.isUndefined(response.message)) {
          // 承認/承認解除結果ダイヤログのタイトル
          const approvalTitle = `作業${this.pageName}の承認解除${
            response.message.includes('完了') ? '完了' : ''
          }`;
          modalList.DynamicSuccessTitle = approvalTitle;
          modalList.DynamicSuccessMessage = response.message;
          this.handleOpenModalById(modalList.DynamicSuccess);
        }
        this.onApprovalChanged();
      });
    }
  );

  /**
   * @description IDを指定して作業の承認をキャンセル
   * @param {number} workApprovalId 承認ID
   */
  handleWorkApprovalCancelByWorkId = workApprovalId => {
    if (this.state.isSelectedWorkLocked) {
      return WorkApprovalService.cancelWorkApproval(
        SessionStorageService.getFieldId(),
        [this.state.selectedWorkId]
      ).then(response => {
        if (response.result === false) {
          return;
        }
        // APIが正しく実行された時はLockフラグを解除する
        this.setState({ isSelectedWorkLocked: false });
        this.onApprovalChanged();
        this.handleOpenModalById(modalList.ApprovalStatus);
      });
    }
    return WorkApprovalService.destroy(
      SessionStorageService.getFieldId(),
      workApprovalId
    ).then(response => {
      if (response.result === false) {
        return;
      }
      if (_.has(response, 'message') && response.message === '') {
        this.handleCloseModal();
      } else if (!_.isUndefined(response.message)) {
        modalList.ApprovedDeniedMessage = response.message;
        this.handleOpenModalById(modalList.ApprovedDenied);
      }
      this.onApprovalChanged();
    });
  };

  /**
   * @description 協力会社承認/否認 実行準備(単数用)
   * @param {number} workId 作業ID
   * @param {boolean} isApproval true: 承認, false: 否認
   */
  partnerApprovalSinglePreparation(workId, isApproval) {
    const { PartnerApprovalConfirm, PartnerDenialConfirm } = modalList;

    this.handleOpenModalById(
      isApproval ? PartnerApprovalConfirm : PartnerDenialConfirm
    );
    this.setState({ partnerApprovalWorkId: workId });
  }

  handleResponsePartnerApprovalRun = (response, isApproval, isBulkApproval) => {
    const errorCode = _.get(response, 'data.data.entities.error_code');
    if (errorCode) {
      this.resetPartnerApprovalValue();
      return this.handleVisibleApprovalWorksErrorModal(
        messageUtility.getMessage(isBulkApproval ? 'E-001-441' : 'E-001-439'),
        messageUtility.getMessage(errorCode)
      );
    }
    if (response.result) {
      let title = '';
      let message = '';
      if (
        _.has(response, 'message') &&
        (response.message.includes(`対象の作業予定は受領済みです。`) ||
          response.message.includes(`対象の作業予定は受領解除済みです。`) ||
          response.message.includes('対象の作業実績は確定解除済みです。') ||
          response.message.includes('対象の作業実績は確定済みです。'))
      ) {
        if (isApproval) {
          title = this.props.isWorkSchedule
            ? '作業予定の受領'
            : '作業実績の確定';
          message = this.props.isWorkSchedule
            ? '選択した作業予定は受領済みです。'
            : '選択した作業実績は確定済みです。';
        } else {
          title = this.props.isWorkSchedule
            ? '作業予定の受領解除'
            : '作業実績の確定解除';
          message = this.props.isWorkSchedule
            ? '選択した作業予定は受領解除済みです。'
            : '選択した作業実績は確定解除済みです。';
        }
        modalList.ApprovedDeniedTitle = title;
        modalList.ApprovedDeniedMessage = message;
        this.handleOpenModalById(modalList.ApprovedDenied);
      } else {
        if (isApproval) {
          title = this.props.isWorkSchedule
            ? '作業予定の受領完了'
            : '作業実績の確定完了';
          message = this.props.isWorkSchedule
            ? '選択した作業予定の受領が完了しました。'
            : '選択した作業実績の確定が完了しました。';
        } else {
          title = this.props.isWorkSchedule
            ? '作業予定の受領解除完了'
            : '作業実績の確定解除完了';
          message = this.props.isWorkSchedule
            ? '選択した作業予定の受領解除が完了しました。'
            : '選択した作業実績の確定解除が完了しました。';
        }
        modalList.DynamicSuccessTitle = title;
        modalList.DynamicSuccessMessage = message;
        this.handleOpenModalById(modalList.DynamicSuccess);
      }
    } else {
      const modalMessage = 'エラーが発生しました。';
      this.handleOpenModalById(modalList.DynamicDesignationMessage);
      this.setState({ modalMessage });
    }
  };

  /**
   * @description 協力会社承認/否認 実行
   * @param {boolean} isApproval true: 承認, false: 否認
   */
  partnerApprovalRun(isApproval) {
    const { selectedWorkIdList, partnerApprovalWorkId } = this.state;
    const fieldId = SessionStorageService.getFieldId();
    const isBulkApproval = _.isNull(partnerApprovalWorkId);
    const workIds = isBulkApproval
      ? selectedWorkIdList
      : [partnerApprovalWorkId];
    const usePartnerApprovalApi = isApproval
      ? () =>
          WorkApprovalService.partnerApproval(
            fieldId,
            workIds,
            _.isNull(partnerApprovalWorkId)
          )
      : () => WorkApprovalService.partnerDenial(fieldId, workIds);
    let modalMessage = '';

    if (workIds.length === 0) {
      modalMessage = `作業${this.pageName}が選択されていません。`;
      this.handleOpenModalById(modalList.DynamicDesignationMessage);
      return this.setState({ modalMessage });
    }

    usePartnerApprovalApi().then(response => {
      this.handleResponsePartnerApprovalRun(
        response,
        isApproval,
        isBulkApproval
      );
      this.onApprovalChanged();
    });
  }

  /**
   * 「実績に反映する」機能
   */
  handleSchedulesReflectOnHistories(fieldId) {
    // console.log('Works.jsx handleSchedulesReflectOnHistories');

    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    // 日付は期間指定ではなくなった。
    const date = SessionStorageService.getFromDate();
    if (!matchFormat('date_yyyy/mm/dd', date)) {
      throw new Error(
        'Works.jsx handleSchedulesReflectOnHistories date format'
      );
    }

    WorkScheduleService.schedulesReflectOnHistories(fieldId, date)
      .then(response => {
        // console.log('Works.jsx handleSchedulesReflectOnHistories', response);
        if (response.data) {
          EventManager.trigger(EventType.REFRESH_UNAPPROVED_WORKS_COUNT);
        }

        if (response.result) {
          // 「実績を反映しました」ダイアログ
          this.handleOpenModalById(
            modalList.CompleteWorkScheduleReflectToResult
          );
        } else {
          // resultがfalseの場合はレスポンスのメッセージを表示
          if (_.size(response.message) > 0) {
            this.handleOpenModalById(
              modalList.AlreadyWorkScheduleReflectToResult,
              response.message
            );
          } else {
            // ないはずだがメッセージなければ閉じるだけ
            this.handleCloseModal();
          }
        }
        this.updatingFlag = false;
      })
      .catch(error => {
        // schedulesReflectOnHistoriesは共通のエラー処理falseになっている
        if (error.status === 400) {
          if (!error.data.result) {
            this.handleCloseModal();
            this.showErrorDialog(error.data.message);
          }
        }
        this.updatingFlag = false;
      });
  }

  renderScrollGroup = groups => {
    const {
      scheduleFlag,
      searchParams,
      isOpenAllGroups,
      selectedWorkGroups,
    } = this.state;
    const { parentId, sort, selected } = this.props;
    const isDisplayReflectTotalColumn = this.isDisplayReflectTotalColumn();

    return _.map(groups, (group, key) => (
      <WorkScrollGroup
        workGroupData={group}
        onUpdateWorksInGroup={this.handleUpdateWorksInGroup}
        loadWorksUnit={this.loadWorksUnit}
        key={`scroll-group-${key}-${group.id || key}`}
        id={`scroll-group-${key}-${group.id || key}`}
        scheduleFlag={scheduleFlag}
        parent={parentId}
        sort={sort}
        selected={selected}
        selectedList={this.state.selectedWorkIdList}
        group_selected={_.includes(selectedWorkGroups, group.id)}
        privatePartnerCompanyFlag={group.private_partner_company_flag}
        searchParams={searchParams}
        groupId={group.id}
        isOpened={isOpenAllGroups}
        onWorkSelect={workId => {
          this.handleWorkSelect(workId);
        }}
        onGroupSelect={(groupId, privatePartnerCompanyFlag, isSelected) => {
          this.handleGroupSelect(
            groupId,
            privatePartnerCompanyFlag,
            isSelected
          );
        }}
        onApprovalStatusClick={this.handleApprovalStatusClick}
        onManHourEditClick={(e, id) => this.onManHourEditClick(e, id)}
        usePartnerCompanyApprovalFlag={this.state.usePartnerCompanyApprovalFlag}
        partnerApprovalName={this.state.partnerApprovalName}
        onPartnerApprovalSinglePreparation={
          this.partnerApprovalSinglePreparation
        }
        workColumnsSettings={this.state.workColumnsSettings}
        isDisplayReflectTotalColumn={isDisplayReflectTotalColumn}
      />
    ));
  };

  // 作業予定の表示
  setScrollGroup(workGroups) {
    return this.renderScrollGroup(workGroups);
  }

  /**
   * @description 承認完了後の処理
   */
  onApprovalChanged = () => {
    this.setState({
      reload: true,
    });
  };

  onManHourChanged = () => {
    this.setState({
      reload: true,
    });
  };

  /**
   * @description モーダル用メッセージリセット
   */
  resetModalMessage() {
    if (this.state.usePartnerCompanyApprovalFlag) {
      this.resetPartnerApprovalValue();
    } else {
      this.handleCloseModal();
    }
    this.setState({ modalMessage: '' });
  }

  /**
   * @description 協力会社承認_値リセット
   */
  resetPartnerApprovalValue() {
    this.handleCloseModal();
    this.setState({ partnerApprovalWorkId: null });
  }

  /**
   * @description モーダルをクローズ
   */
  handleCloseModal = () => {
    this.setState({
      showModal: false,
      selectedModalId: modalList.Unloaded,
      copyErrorMessage: null,
    });
  };

  rollbackSafetyDutyUser = () => {
    this.setState({
      showModal: false,
      selectedModalId: modalList.Unloaded,
      reload: true,
      safetyDutyUser: this.state.beforeSafetyDutyUser,
      beforeSafetyDutyUser: [],
    });
  };

  // 日付系パラメータを検索パラメータに含める
  mergeDateParameter(sourceParams) {
    return {
      ...sourceParams,
      work_hour_zone: SessionStorageService.getWorkHourZone(),
      date_from: SessionStorageService.getFromDate(),
      date_to: SessionStorageService.getToDate(),
    };
  }

  // 行の作業承認状態のクリックイベントのハンドリング
  handleApprovalStatusClick = (id, isLocked = false) => () => {
    this.setState({ selectedWorkId: id, isSelectedWorkLocked: isLocked });
    this.handleOpenModalById(modalList.ApprovalStatus);
  };

  /**
   * 行の人工編集のクリックイベントのハンドリング
   * @param {number}id
   */
  onManHourEditClick = id => {
    this.setState({ selectedWorkId: id });
    this.handleOpenModalById(modalList.ManHourInput);
  };

  // 作業コピー
  handleCopyWorkSchedule = onceAsyncRequest(async (list, copyDate) => {
    await WorkScheduleService.copyWorks(
      SessionStorageService.getFieldId(),
      list,
      copyDate
    ).then(response => {
      if (response.status === 400) {
        if (!response.data.result) {
          this.handleCloseModal();
          this.showErrorDialog(response.data.message);
        }
      } else {
        if (response.result === true) {
          this.handleCloseModal();
          this.setState({ reload: true });
          if (response.data.entities.manager_user_id_reset) {
            this.handleOpenModalById(modalList.CopyWorksNotComplete);
          }
        } else {
          this.setState({ copyErrorMessage: response.data.message });
        }
      }
    });
  });

  // 安全当番ドロップダウン選択 日付選択(単独日付)
  handleUpdateSafetyDuties = user_id => {
    const field_id = SessionStorageService.getFieldId();
    const work_date = SessionStorageService.getFromDate();
    const work_hour_zone = SessionStorageService.getWorkHourZone();
    if (_.isNull(user_id)) {
      // 安全当番解除処理
      SafetyDutyService.deleteDuty(SessionStorageService.getFieldId(), {
        field_id,
        work_date,
        work_hour_zone,
      }).then(response => {
        if (!response.result) {
          return;
        }
        this.setState({ safetyDutyUser: [], safetyDutyUserName: '' });
      });
      return;
    } else {
      // 安全当番設定処理
      SafetyDutyService.register(SessionStorageService.getFieldId(), {
        user_id,
        field_id,
        work_date,
        work_hour_zone,
      }).then(response => {
        if (!response.result) {
          return;
        }
        if (_.get(response, 'data.entities.user_has_linked_status_deactive')) {
          this.setState({ safetyDutyUser: this.state.safetyDutyUser });
          return;
        }
        this.setState({ safetyDutyUser: [user_id] });
      });
    }
  };

  // 安全当番指定 ドロップダウンボタンでの確定
  handleUpdateKikanSafetyDuties = () => {
    const fromDate = moment(SessionStorageService.getFromDate(), 'YYYY/MM/DD');
    const toDate = moment(SessionStorageService.getToDate(), 'YYYY/MM/DD');
    if (fromDate.isAfter(toDate)) {
      throw new Error(
        'Works.jsx handleUpdateKikanSafetyDuties not fromDate < toDate'
      );
    }

    if (this.state.safetyDutyUser.length === 0) {
      // 安全当番解除処理
      SafetyDutyService.kikanDelete(SessionStorageService.getFieldId(), {
        field_id: SessionStorageService.getFieldId(),
        work_date_from: fromDate.format('YYYY/MM/DD'),
        work_date_to: toDate.format('YYYY/MM/DD'),
        work_hour_zone: SessionStorageService.getWorkHourZone(),
      }).then(response => {
        if (!response.result) {
          return;
        }
      });
    } else {
      // 安全当番設定処理
      let dateRange = [];
      for (
        let date = fromDate;
        date.isSameOrBefore(toDate);
        date = date.add(1, 'day')
      ) {
        dateRange.push(date.format('YYYY/MM/DD'));
      }
      SafetyDutyService.kikanRegister(SessionStorageService.getFieldId(), {
        field_id: SessionStorageService.getFieldId(),
        user_id: this.state.safetyDutyUser[0],
        work_dates: dateRange,
        work_hour_zone: SessionStorageService.getWorkHourZone(),
      }).then(response => {
        if (!response.result) {
          return;
        }
        if (_.get(response, 'data.entities.user_has_linked_status_deactive')) {
          this.rollbackSafetyDutyUser();
          return;
        }
      });
    }
    this.handleCloseModal();
    return;
  };

  // 検索条件の変更ハンドリング
  setSearchParam = () => {
    this.setState({ searchParams: _.cloneDeep(this.state.tempSearchParams)});
  }

  // 検索条件のリセット
  resetSearchParam = () => {
    this.setState({
      options: {},
      searchParams: { schedule_flag: this.state.scheduleFlag },
      selectedWorkGroups: [],
      tempSearchParams: { schedule_flag: this.state.scheduleFlag },
    });
  }

  // 検索条件(保存用)の変更ハンドリング
  setTempSearchParam = (name, value) => {
    this.setState(prevState => ({
      tempSearchParams: {
        ...prevState.tempSearchParams,
        [name]: value,
      },
    }));
  }

  isPrintButtonVisible = () => {
    return (
      this.state.workReportDownloadableFlag &&
      SessionStorageService.getFromDate() === SessionStorageService.getToDate()
    );
  };

  renderReflectedWorkTooltip = () => {
    return (
      <div
        style={{
          maxWidth: 260,
          wordWrap: 'break-word',
          color: '#FFF',
          fontSize: 14,
          lineHeight: '1.5',
          textAlign: 'left',
        }}
      >
        同一施工体制に作業実績が複数件ある場合は先頭行にのみ数値が表示されます。
      </div>
    );
  };

  isDisplayReflectTotalColumn = () => {
    return (
      !this.props.isWorkSchedule &&
      this.state.checkInReflectToResultFlag &&
      sessionStorage.getItem('work_hour_zone') === WORK_HOUR_ZONES.day.key
    );
  };

  tableHeader = () => {
    const isConferenceMode =
      SessionStorageService.getItem('is_conference') === CONFERENCE_MODE.on.key;
    const { workColumnsSettings } = this.state;
    const workColumnItems = isConferenceMode
      ? workColumnsSettings.conference_order
      : workColumnsSettings.list_order;
    const isDisplayReflectTotalColumn = this.isDisplayReflectTotalColumn();

    return (
      <thead className='data-table__header'>
        <tr className=''>
          <th className='data-table__head data-table__head--collapse'>
            開閉
            <button
              className='btn-icon--xs--dark'
              onClick={this.handleToggleOpenAllWorkGroups(
                !this.state.isOpenAllGroups
              )}
            >
              <i
                className={`i-warrow-${
                  this.state.isOpenAllGroups ? 'top' : 'bottom'
                } i-2x`}
              />
            </button>
          </th>
          {isConferenceMode ? null : (
            <React.Fragment>
              {/* チェックボックス */}
              <th className='data-table__head' />
            </React.Fragment>
          )}
          {_.map(workColumnItems, item => {
            if (
              item.type === 'approvals' &&
              this.state.usePartnerCompanyApprovalFlag === true
            ) {
              return (
                <React.Fragment key={item.type}>
                  <th className='data-table__head'>元請会社承認</th>
                  <th className='data-table__head'>
                    協力会社{this.state.partnerApprovalName}
                  </th>
                </React.Fragment>
              );
            } else {
              return (
                <React.Fragment key={item.type}>
                  <th className='data-table__head'>
                    {item.name}
                  </th>
                  {item.type === 'man_hours' && isDisplayReflectTotalColumn && (
                    <th className='data-table__head'>
                      <div className='data-table__head--guide'>
                        入場人数
                        <Tippy
                          duration={10}
                          distance={24}
                          arrow={true}
                          arrowType='sharp'
                          delay={[100, 100]}
                          placement='bottom'
                          followCursor={true}
                          html={this.renderReflectedWorkTooltip()}
                        >
                          <QuestionIcon className='icon--2x question-icon' />
                        </Tippy>
                      </div>
                    </th>
                  )}
                </React.Fragment>
              );
            }
          })}
        </tr>
      </thead>
    );
  };

  // レンダリング時に別途協力会社を振り分ける
  memoizeWorkGroupsPartition = workGroups => {
    // 重い処理ではないがレンダリングの度に呼ばれるのでメモ化しておく
    if (this.workGroupsPartitionParamMemo === workGroups) {
      return this.workGroupsPartitionResultMemo;
    }

    // 別途協力会社の作業の振り分け
    const [notPrivateWorkGroups, privateWorkGroups] = _.partition(workGroups, {
      private_partner_company_flag: PRIVATE_COMPANY_FLAG.NotPrivate,
    });

    const result = {
      notPrivateWorkGroups: notPrivateWorkGroups || [],
      privateWorkGroups: privateWorkGroups || [],
    };

    this.workGroupsPartitionParamMemo = workGroups;
    this.workGroupsPartitionResultMemo = result;

    return result;
  };

  showErrorDialog(message, buttonText) {
    dialogLoader.show(ErrorDialog, {
      message,
      buttonText,
      callback: {
        close: () => {
          dialogLoader.close();
        },
      },
    });
  }

  showErrorScreenDialog(message, buttonText) {
    dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('E-001-415'),
      message,
      buttonText,
      onClose: () => {
        dialogLoader.close();
      },
    });
  }

  moveToBatchUpdatePage = () => {
    if (this.props.isWorkSchedule) {
      this.props.loadPage(WorkScheduleBatchEdit, this.props.param);
      urlParamManger.setPage('WorkScheduleBatchEdit', this.props.vw);
      urlParamManger.publish();
      setTimeout(() => {
        EventManager.trigger(EventType.LAYOUT_UPDATE, {});
      }, 1);
      return;
    }
    this.props.loadPage(WorkResultBatchEdit, this.props.param);
    urlParamManger.setPage('WorkResultBatchEdit', this.props.vw);
    urlParamManger.publish();
    setTimeout(() => {
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    }, 1);
  };

  handleShowDialogConfirm = (
    selectedBatchWorkIdList,
    moveToBatchUpdate = false
  ) => {
    if (selectedBatchWorkIdList.length > 0) {
      const selectedBatchWorkListIdsSorted = _.filter(this.workIds, id =>
        selectedBatchWorkIdList.includes(id)
      );
      SessionStorageService.setSelectedBatchWorkListIds(
        selectedBatchWorkListIdsSorted
      );
      if (moveToBatchUpdate) {
        this.moveToBatchUpdatePage();
      } else {
        this.handleOpenModalById(modalList.BatchUpdateConfirm);
      }
    } else {
      this.handleOpenModalById(modalList.BatchUpdateIgnore);
    }
  };

  handleMoveToBatchUpdate = () => {
    let selectedBatchWorkIdList = _.cloneDeep(this.state.selectedWorkIdList);
    if (_.isEmpty(selectedBatchWorkIdList)) {
      return;
    }
    if (selectedBatchWorkIdList.length > MAX_WORKERS_ALLOW) {
      this.setState({ maxRecord: MAX_WORKERS_ALLOW });
      this.handleOpenModalById(modalList.ReachMaxNumber);
      return;
    }
    selectedBatchWorkIdList = selectedBatchWorkIdList.filter(val => {
      return (
        !this.workSuspendedListsIds.includes(val) &&
        (!this.state.usePartnerCompanyApprovalFlag ||
          !this.partnerApprovalListsIds.includes(val)) &&
        !this.approvedListIds.includes(val)
      );
    });
    this.handleShowDialogConfirm(
      selectedBatchWorkIdList,
      _.isEqual(selectedBatchWorkIdList, this.state.selectedWorkIdList)
    );
  };

  isActiveNotReflectedButton = () => {
    return !this.props.isWorkSchedule && this.state.workResultNotReflectedFlag;
  };

  handleVisibleApprovalWorksErrorModal = (
    approvalErrorTitle = '',
    approvalErrorMessage = ''
  ) =>
    this.setState({
      approvalErrorTitle,
      approvalErrorMessage,
    });

  render() {
    const isConferenceMode =
      SessionStorageService.getItem('is_conference') === CONFERENCE_MODE.on.key;
    const isWorkSchedule = this.props.isWorkSchedule;
    const {
      notPrivateWorkGroups,
      privateWorkGroups,
    } = this.memoizeWorkGroupsPartition(this.state.workGroups);
    const isPrivateCompanyWorkVisible =
      this.state.searchPrivatePartnerCompanyState !==
        PRIVATE_COMPANY_SERACH_STATE.NotPrivate &&
      _.size(privateWorkGroups) !== 0;
    if (isPrivateCompanyWorkVisible) {
      // [1,2,3,4]
      SessionStorageService.setPrivateBatchWorkListIds(
        _.flatten(
          _.map(privateWorkGroups, workGroups => {
            return _.map(workGroups.works, work => {
              return work.id;
            });
          })
        )
      );
    } else {
      SessionStorageService.setPrivateBatchWorkListIds([]);
    }
    const loadedWorkTotal = _.size(this.state.workGroups);

    const slide = urlParamManager.getSlideParam();
    const buttonDisabled = this.state.selectedWorkIdList.length === 0;
    const isDisplayNotReflectedButton = this.isDisplayReflectTotalColumn();
    const isDisableNotReflectedButton = !this.isActiveNotReflectedButton();
    const { approvalErrorTitle, approvalErrorMessage } = this.state;

    return (
      <div id='main' className='main'>
        {slide[0] === '0' && ( // リロード時他ページのtitleを上書きする問題の対策
          <Helmet>
            <title>
              {HEADER_CONSTANTS.conference} - 作業
              {isWorkSchedule ? `予定` : `実績`}
              一覧
            </title>
          </Helmet>
        )}

        <ConferencePageHeader
          dataTestId={isWorkSchedule ? `work-schedule` : `work-result`}
          title={
            <React.Fragment>
              作業{isWorkSchedule ? `予定` : `実績`}一覧
            </React.Fragment>
          }
          middleComponent={
            this.state.usePartnerCompanyApprovalFlag && (
              <UnapprovedWorksPageHeader />
            )
          }
        />
        <div id='scrolll-parent' className='main__body'>
          <div className='schedulelist'>
            {!isConferenceMode ? (
              <div className='schedulelist__header'>
                <ul className='btn-menu'>
                  <li className='btn-menu__item'>
                    {this.state.selectedWorkIdList.length === 0 ? (
                      <button
                        className='btn'
                        onClick={() => {
                          isWorkSchedule
                            ? _slideLoader.show(
                                'WorkScheduleRegister',
                                this.FormNew,
                                this.props.vw
                              )
                            : _slideLoader.show(
                                'WorkResultRegister',
                                this.FormNew,
                                this.props.vw
                              );
                        }}
                      >
                        新規作成
                      </button>
                    ) : (
                      <button
                        className='btn'
                        onClick={() => {
                          this.handleOpenModalById(modalList.CopyWorks);
                        }}
                      >
                        選択項目をコピー
                      </button>
                    )}
                  </li>
                  <Auth approvedRoles={ContractorRoles}>
                    {this.state.batchEditButton && (
                      <BatchUpdateButton
                        disabled={buttonDisabled}
                        handleMoveToBatchUpdate={() =>
                          this.reLoadGroupData(this.handleMoveToBatchUpdate)
                        }
                        pageName={this.pageName}
                      />
                    )}
                  </Auth>
                  <Auth approvedRoles={ContractorRoles}>
                    {!this.state.workApprovalButtonEnabled ? null : (
                      <React.Fragment>
                        <li className='btn-menu__item sm--hidden md--hidden'>
                          <div className='segment-line' />
                        </li>
                        <li className='btn-menu__item'>
                          <button
                            id='modal-open-confirm-selected'
                            className={`btn--effective ${
                              buttonDisabled ? 'btn-disabled' : ''
                            }`}
                            disabled={buttonDisabled}
                            onClick={() => {
                              this.handleOpenModalById(
                                modalList.ConfirmSelected
                              );
                            }}
                          >
                            選択項目を承認
                          </button>
                        </li>
                        <li className='btn-menu__item'>
                          <button
                            id='modal-open-confirm-deselected'
                            className={`btn--negative ${
                              buttonDisabled ? 'btn-disabled' : ''
                            }`}
                            disabled={buttonDisabled}
                            onClick={() => {
                              this.handleOpenModalById(
                                modalList.ConfirmDeselected
                              );
                            }}
                          >
                            選択項目の承認解除
                          </button>
                        </li>
                      </React.Fragment>
                    )}
                  </Auth>
                  {this.state.usePartnerCompanyApprovalFlag && (
                    <React.Fragment>
                      <li className='btn-menu__item sm--hidden md--hidden'>
                        <div className='segment-line' />
                      </li>
                      <SubContractorToggle>
                        <li className='btn-menu__item'>
                          <button
                            id='modal-open-confirm-selected'
                            className={`btn--effective ${
                              buttonDisabled ? 'btn-disabled' : ''
                            }`}
                            disabled={buttonDisabled}
                            onClick={() =>
                              this.handleOpenModalById(
                                modalList.PartnerApprovalConfirm
                              )
                            }
                          >
                            {`選択項目を${this.state.partnerApprovalName}`}
                          </button>
                        </li>
                      </SubContractorToggle>
                      <li className='btn-menu__item'>
                        <button
                          id='modal-open-confirm-deselected'
                          className={`btn--negative ${
                            buttonDisabled ? 'btn-disabled' : ''
                          }`}
                          disabled={buttonDisabled}
                          onClick={() =>
                            this.handleOpenModalById(
                              modalList.PartnerDenialConfirm
                            )
                          }
                        >
                          {`選択項目の${this.state.partnerApprovalName}解除`}
                        </button>
                      </li>
                    </React.Fragment>
                  )}
                </ul>
                <ul className='btn-menu'>
                  {!(
                    isWorkSchedule && !SessionStorageService.getIsTerm()
                  ) ? null : (
                    <Auth approvedRoles={ContractorRoles}>
                      <li className='btn-menu__item sm--hidden'>
                        <button
                          className='btn--sub'
                          onClick={() => {
                            this.handleOpenModalById(
                              modalList.ScheduleRefrectToResult
                            );
                          }}
                        >
                          実績に反映
                        </button>
                      </li>
                    </Auth>
                  )}
                  {isDisplayNotReflectedButton && (
                    <li className='btn-menu__item sm--hidden'>
                      <button
                        className={`btn--sub ${
                          isDisableNotReflectedButton ? 'btn-disabled' : ''
                        }`}
                        disabled={isDisableNotReflectedButton}
                        onClick={() =>
                          this.handleOpenModalById(
                            modalList.CheckInNotReflectWorksDialog
                          )
                        }
                      >
                        入場実績の未反映数
                      </button>
                    </li>
                  )}
                  <li className='btn-menu__item sm--hidden'>
                    <button
                      id='modal-open-jinkou'
                      className='btn--sub'
                      onClick={() => {
                        this.handleOpenModalById(modalList.ManHour);
                      }}
                    >
                      表示項目の全人工合計
                    </button>
                  </li>
                  {this.isPrintButtonVisible() && (
                    <li className='btn-menu__item sm--hidden'>
                      <button
                        className='btn--sub'
                        onClick={() => this.handlePrintOutClicked()}
                      >
                        印刷
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            ) : (
              // 会議モードの場合
              <div className='schedulelist__header'>
                <ul className='btn-menu'>
                  <li className='btn-menu__item'>
                    <button
                      className='btn'
                      onClick={() => {
                        isWorkSchedule
                          ? _slideLoader.show(
                              'WorkScheduleRegister',
                              this.FormNew,
                              this.props.vw
                            )
                          : _slideLoader.show(
                              'WorkResultRegister',
                              this.FormNew,
                              this.props.vw
                            );
                      }}
                    >
                      新規作成
                    </button>
                  </li>
                  {isDisplayNotReflectedButton && (
                    <li className='btn-menu__item sm--hidden'>
                      <button
                        className={`btn--sub ${
                          isDisableNotReflectedButton ? 'btn-disabled' : ''
                        }`}
                        disabled={isDisableNotReflectedButton}
                        onClick={() =>
                          this.handleOpenModalById(
                            modalList.CheckInNotReflectWorksDialog
                          )
                        }
                      >
                        入場実績の未反映数
                      </button>
                    </li>
                  )}
                  <li className='btn-menu__item sm--hidden'>
                    <button
                      id='modal-open-jinkou'
                      className='btn--sub'
                      onClick={() => {
                        this.handleOpenModalById(modalList.ManHour);
                      }}
                    >
                      表示項目の全人工合計
                    </button>
                  </li>
                  {this.isPrintButtonVisible() && (
                    <li className='btn-menu__item sm--hidden'>
                      <button
                        className='btn--sub'
                        onClick={() => this.handlePrintOutClicked()}
                      >
                        印刷
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            )}

            <WorkSearchForm
              value={this.state.displayFlg}
              onSetSearchParam={this.setSearchParam}
              onResetSearchParam={this.resetSearchParam}
              scheduleFlag={this.state.scheduleFlag}
              workTotal={this.state.searchCount}
              fieldId={SessionStorageService.getFieldId()}
              isConferenceMode={isConferenceMode}
              options={this.state.options}
              loaded={this.state.loaded}
              usePartnerCompanyApprovalFlag={
                this.state.usePartnerCompanyApprovalFlag
              }
              partnerApprovalName={this.state.partnerApprovalName}
              isLoading={this.state.isLoading}
              tempSearchParams={this.state.tempSearchParams}
              onSetTempSearchParam={this.setTempSearchParam}
            />
            <div className='schedulelist__list-header'>
              <ul className='btn-menu'>
                {!isConferenceMode && (
                  <React.Fragment>
                    <li className='btn-menu__item'>
                      <button
                        id='btn-check-all'
                        className={
                          this.state.selectedWorkIdList.length !==
                          _.sum(
                            this.state.workGroups.map(group =>
                              !_.isArray(group.works) ? 0 : group.works.length
                            )
                          )
                            ? `btn--stay`
                            : `btn--sub btn-disabled`
                        }
                        onClick={() => this.handleSelectAll(true)}
                      >
                        表示項目をすべて選択
                      </button>
                    </li>
                    <li className='btn-menu__item'>
                      <span className='selected-work__text'>
                        {this.state.selectedWorkIdList.length}件選択中
                      </span>
                    </li>
                    <li className='btn-menu__item'>
                      <button
                        id='btn-uncheck-all'
                        className={
                          this.state.selectedWorkIdList.length > 0
                            ? `btn-text`
                            : `btn-text--sub disabled`
                        }
                        disabled={this.state.selectedWorkIdList.length === 0}
                        onClick={() => this.handleSelectAll(false)}
                      >
                        選択中の項目を解除
                      </button>
                    </li>
                  </React.Fragment>
                )}
                <Auth approvedRoles={ContractorRoles}>
                  <li className='btn-menu__item-dropdown set-width-dropdown'>
                    <div
                      className={`safety-dropdown ${
                        isConferenceMode ? 'safety-dropdown__no-margin' : ''
                      }`}
                    >
                      <div className='btn-menu__item-label'>
                        <span>安全当番</span>
                      </div>
                      <SafetyDutyUserDropdown
                        value={this.state.safetyDutyUser}
                        name={this.state.safetyDutyUserName}
                        onSelect={(name, value) =>
                          this.handleUpdateSafetyDuties(value)
                        }
                        onSelectKikan={(name, value) =>
                          this.handleKikanModal(value)
                        }
                        isOptional={true}
                      />
                    </div>
                  </li>
                </Auth>
              </ul>
            </div>
            <div className='schedulelist__content'>
              <div
                className='schedulelist__list'
                id='scroll-parent-non-private-work'
              >
                <table className='data-table'>
                  {this.tableHeader()}
                  {this.setScrollGroup(notPrivateWorkGroups)}
                  {isPrivateCompanyWorkVisible && (
                    <React.Fragment>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              background: '#1A1A1A',
                              color: 'white',
                              padding: '6px',
                              fontSize: 12,
                            }}
                            colSpan='50'
                          >
                            以下、別途協力会社
                          </td>
                        </tr>
                      </tbody>
                      {this.setScrollGroup(privateWorkGroups)}
                    </React.Fragment>
                  )}
                </table>

                <WorksInfinityScrollLoad
                  targetId={'scroll-parent-non-private-work'}
                  callback={this.addLoadGroupData}
                  loaded={this.state.workTotal <= loadedWorkTotal}
                  total={this.state.workTotal}
                  isLoading={this.state.isLoading}
                />
                {this.state.isLoading ? null : this.state.workTotal !==
                  0 ? null : (
                  <div className='table-has-no-data'>
                    <div className='table-has-no-data__message'>
                      {messageUtility.getMessage('I-000-005')}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Modal modalRoot='root' modalState={this.state.showModal}>
          {this.setModalById(this.state.selectedModalId)}
        </Modal>
        {/* 承認・否認時に表示するダイアログ */}
        <Information
          title={modalList.ApprovedDeniedTitle}
          visible={this.state.selectedModalId === modalList.ApprovedDenied}
          message={modalList.ApprovedDeniedMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={this.resetModalMessage}
          multilineText={true}
        />
        <Information
          title={modalList.DynamicSuccessTitle}
          visible={this.state.selectedModalId === modalList.DynamicSuccess}
          message={modalList.DynamicSuccessMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={this.resetModalMessage}
          multilineText={true}
        />
        <Information
          title={messageUtility.getMessage('I-001-434')}
          visible={
            this.state.selectedModalId === modalList.CopyWorksNotComplete
          }
          message={messageUtility.getMessage(
            'I-001-435',
            `作業${this.pageName}`
          )}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => {
            this.handleCloseModal();
          }}
          multilineText={true}
        />
        <Confirmation
          visible={this.state.selectedModalId === modalList.ConfirmSelected}
          title={messageUtility.getMessage('I-001-407', `作業${this.pageName}`)}
          message={messageUtility.getMessage(
            'I-001-404',
            `作業${this.pageName}`
          )}
          confirmButtonText={messageUtility.getMessage('I-000-007')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() =>
            this.handleWorkApproval(
              SessionStorageService.getFieldId(),
              this.state.selectedWorkIdList
            )
          }
          onCancel={this.handleCloseModal}
        />
        {/* 承認解除_確認ダイアログ */}
        {/* eslint-disable */}
        <Confirmation
          visible={this.state.selectedModalId === modalList.ConfirmDeselected}
          title={messageUtility.getMessage('I-001-408', `作業${this.pageName}`)}
          message={
            this.state.usePartnerCompanyApprovalFlag
              ? messageUtility.getMessage(
                  'I-001-416',
                  this.state.partnerApprovalName,
                  this.pageName,
                  '承認'
                )
              : messageUtility.getMessage('I-001-405', `作業${this.pageName}`)
          }
          confirmButtonText={messageUtility.getMessage('I-000-020')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() =>
            this.handleWorkApprovalCancel(
              SessionStorageService.getFieldId(),
              this.state.selectedWorkIdList
            )
          }
          onCancel={this.handleCloseModal}
          isNegative={true}
        />

        {/* 協力会社承認_確認ダイアログ */}
        <Confirmation
          visible={
            this.state.selectedModalId === modalList.PartnerApprovalConfirm
          }
          title={`
          作業${this.pageName}の${this.state.partnerApprovalName}`}
          message={messageUtility.getMessage(
            'I-001-415',
            this.state.partnerApprovalName,
            this.pageName
          )}
          confirmButtonText={this.state.partnerApprovalName}
          cancelButtonText='戻る'
          onConfirm={() => this.partnerApprovalRun(true)}
          onCancel={this.resetPartnerApprovalValue}
        />

        {/* 協力会社否認_確認ダイアログ */}
        <Confirmation
          visible={
            this.state.selectedModalId === modalList.PartnerDenialConfirm
          }
          title={`作業${this.pageName}の${this.state.partnerApprovalName}解除`}
          message={messageUtility.getMessage(
            'I-001-416',
            this.state.partnerApprovalName,
            this.pageName,
            this.state.partnerApprovalName
          )}
          isNegative={true}
          confirmButtonText={`${this.state.partnerApprovalName}解除`}
          cancelButtonText='戻る'
          onConfirm={() => this.partnerApprovalRun(false)}
          onCancel={this.resetPartnerApprovalValue}
        />
        {/* eslint-enable */}

        {/* タイトル「MM/DD-MM/DDの作業予定を実績に反映」
            ボタン「実績に反映する」「戻る」 */}
        <Confirmation
          visible={
            this.state.selectedModalId === modalList.ScheduleRefrectToResult
          }
          title={'実績に反映する'}
          message={messageUtility.getMessage(
            'I-001-406',
            this.state.reflectDate
          )}
          confirmButtonText={messageUtility.getMessage('I-001-316')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() => {
            this.handleSchedulesReflectOnHistories(
              SessionStorageService.getFieldId()
            );
          }}
          onCancel={this.handleCloseModal}
        />
        {/* タイトル「実績に反映」
            本文「実績に反映しました」
            ボタン「戻る」 */}
        <Information
          visible={
            this.state.selectedModalId ===
            modalList.CompleteWorkScheduleReflectToResult
          }
          onClose={this.handleCloseModal}
          title={messageUtility.getMessage('I-001-351')}
          message={messageUtility.getMessage('I-001-352')}
          buttonText={messageUtility.getMessage('I-000-008')}
        />
        {/* タイトル「実績に反映」
            本文「APIレスポンスのmessage」
            ボタン「戻る」 */}
        <Information
          visible={
            this.state.selectedModalId ===
            modalList.AlreadyWorkScheduleReflectToResult
          }
          onClose={this.handleCloseModal}
          title={messageUtility.getMessage('I-001-351')}
          message={this.state.message}
          buttonText={messageUtility.getMessage('I-000-008')}
        />

        {/* メッセージ指定_動的 */}
        <Information
          visible={
            this.state.selectedModalId === modalList.DynamicDesignationMessage
          }
          message={this.state.modalMessage}
          buttonText='了解'
          onClose={this.resetModalMessage}
        />
        <Information
          title='一括編集できません'
          visible={this.state.selectedModalId === modalList.ReachMaxNumber}
          message={`一度に編集できる作業${this.pageName}の上限は${this.state.maxRecord}件です。選択数を減らしてください。`}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={this.resetModalMessage}
          multilineText={true}
        />
        <Information
          rootClassName='WorkBatchEdit__dialog-info'
          title='一括編集できないデータが含まれています'
          visible={this.state.selectedModalId === modalList.BatchUpdateIgnore}
          message={
            this.props.isWorkSchedule ? (
              <React.Fragment>
                <p>選択した作業予定に編集できないものが含まれています。</p>
                <p>
                  編集したい場合は一度「閉じる」を押してから以下の状態を解除してください。
                </p>
                <ul className='description-list'>
                  <li>
                    承認済または受領済みの作業予定は一覧から解除を行ってください。
                  </li>
                  <li>
                    中止となっている作業予定は個別に中止の取り消しを行ってください。
                  </li>
                </ul>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <p>選択した作業実績に編集できないものが含まれています。</p>
                <p>
                  編集したい場合は一度「閉じる」を押してから以下の状態を解除してください。
                </p>
                <ul className='description-list'>
                  <li>
                    承認済または確定済の作業実績は一覧から解除を行ってください。
                  </li>
                  <li>
                    中止となっている作業実績は個別に中止の取り消しを行ってください。
                  </li>
                </ul>
              </React.Fragment>
            )
          }
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={this.resetModalMessage}
          multilineText={true}
        />
        <Confirmation
          rootClassName='WorkBatchEdit__dialog-info'
          title='一括編集できないデータが含まれています'
          visible={this.state.selectedModalId === modalList.BatchUpdateConfirm}
          message={
            this.props.isWorkSchedule ? (
              <React.Fragment>
                <p>選択した作業予定に編集できないものが含まれています。</p>
                <p>
                  編集したい場合は一度「閉じる」を押してから以下の状態を解除してください。
                </p>
                <ul className='description-list'>
                  <li>
                    承認済または受領済みの作業予定は一覧から解除を行ってください。
                  </li>
                  <li>
                    中止となっている作業予定は個別に中止の取り消しを行ってください。
                  </li>
                </ul>
                <p>編集可能な作業予定のみ一括編集を行います。</p>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <p>選択した作業実績に編集できないものが含まれています。</p>
                <p>
                  編集したい場合は一度「閉じる」を押してから以下の状態を解除してください。
                </p>
                <ul className='description-list'>
                  <li>
                    承認済または確定済の作業実績は一覧から解除を行ってください。
                  </li>
                  <li>
                    中止となっている作業実績は個別に中止の取り消しを行ってください。
                  </li>
                </ul>
                <p>編集可能な作業実績のみ一括編集を行います。</p>
              </React.Fragment>
            )
          }
          confirmButtonText='一括編集'
          effectiveButtonClassName='btn'
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          onConfirm={this.moveToBatchUpdatePage}
          onCancel={this.resetModalMessage}
        />
        <Confirmation
          visible={
            this.state.selectedModalId === modalList.WorkReportDownloadError
          }
          title={messageUtility.getMessage('E-001-402')}
          message={messageUtility.getMessage('E-001-411')}
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          confirmButtonText={messageUtility.getMessage('I-000-180')}
          multilineText={true}
          onCancel={this.resetModalMessage}
          onConfirm={() => window.location.reload()}
        />
        <Information
          title={approvalErrorTitle}
          visible={!!approvalErrorMessage}
          message={approvalErrorMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleApprovalWorksErrorModal()}
          multilineText={true}
        />
      </div>
    );
  }
}

const BatchUpdateButton = props => {
  const disabledOldSafari = isSafariStopVersion(); // Safari 13 and lower are not supported
  const { disabled, handleMoveToBatchUpdate, pageName } = props;
  const isDisabled = disabled || disabledOldSafari;
  let tooltipMessage = messageUtility.getMessage('I-001-510', pageName, MAX_WORKERS_ALLOW);
  if (disabledOldSafari) {
    tooltipMessage = messageUtility.getMessage('I-001-511');
  }
  return (
    <div className='BatchUpdateButton'>
      <Tippy
        duration={10}
        distance={24}
        arrow='true'
        arrowType='sharp'
        delay={[100, 100]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(tooltipMessage)}
      >
        <div className='btn-menu__item'>
          <button
            className={`btn ${isDisabled ? 'btn-disabled' : ''}`}
            onClick={handleMoveToBatchUpdate}
            disabled={isDisabled}
          >
            選択項目を一括編集
          </button>
          <QuestionIcon className={'icon--2x question-icon'} />
        </div>
      </Tippy>
    </div>
  );
};

const renderTooltipContent = data => {
  const rowStyle = {
    whiteSpace: 'pre-wrap',
  };

  return (
    <div className='tippy-tooltip' style={rowStyle}>
      {data}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Works.jsx